"use strict";

export default function () {

    const eventSticky = document.querySelector('.event-sticky');

    if (eventSticky) {
        const navLinks = Array.from(document.querySelectorAll('.event-sticky__link'));

        const sections = document.querySelectorAll('[data-nav-title]');
        const sectionsFilter = Array.from(sections).filter(section => section.id);

        window.addEventListener('scroll', function() {
            const eventHeader = document.querySelector('.event-header');
            const pageHeader = document.querySelector('.page-header');
            let rect = null;

            if (eventHeader) {
                rect = eventHeader.getBoundingClientRect();
            } else if (pageHeader) {
                rect = pageHeader.getBoundingClientRect();
            } else {
                const globalGroup = document.querySelector('.global-group--page');
                rect = globalGroup ? globalGroup.getBoundingClientRect() : null;
            }
            const footer = document.querySelector('.global-footer__main');
            var footerVisible = false;
            if (footer) {
                const fRect = footer.getBoundingClientRect();
                footerVisible = fRect.top <= window.innerHeight && fRect.bottom >= 0;
            }

            if (rect && rect.bottom <= window.innerHeight / 2 && !footerVisible) {
                eventSticky.classList.add('show');
            } else {
                eventSticky.classList.remove('show');
            }
        }, { passive: true });

        document.addEventListener('click', function(e){
            const link = e.target;

            if (link.classList.contains('event-sticky__link')){
                const id = link.getAttribute('href').slice(1);
                const block = document.getElementById(id);

                if (block) {
                    e.preventDefault();
                    block.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            }

            if (link.closest && link.closest('.event-sticky__top')){
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }
        });


        // Scroll for event nav links
        if (window.location.hash) {
            const targetElement = document.getElementById(window.location.hash.slice(1));
            if (targetElement != null) {
                const globalHeader = document.querySelector('.global-header');
                const stickyNavHeight = globalHeader ? globalHeader.offsetHeight : 0;


                let targetPosition;

                if (document.querySelector('.event-sticky__nav')) {
                    const eventNavHeight = document.querySelector('.event-sticky__nav').offsetHeight;
                    targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - stickyNavHeight - eventNavHeight;
                } else if (document.querySelector('.global-alerts')) {
                    const globalBannerHeight = document.querySelector('.global-alerts').offsetHeight;
                    targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - stickyNavHeight - globalBannerHeight;
                } else {
                    targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - stickyNavHeight;
                }

                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            }
        }

        // Active state for nav links
        const getSwiper = () => document.querySelector('.event-sticky__nav')?.swiper;

        const setActiveLink = target => {
            navLinks.forEach(link => link.classList.remove('active'));
            target.classList.add('active');

            const swiper = getSwiper();
            const slideEl = target.closest('.swiper-slide');

            if (swiper && slideEl) {
                const slides = Array.from(swiper.slides);
                const index = slides.indexOf(slideEl);
                if (index !== -1) {
                    swiper.slideTo(index);
                }
            } else {
                target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                    inline: 'center'
                });
            }
        };

        if (navLinks.length) {
            navLinks.forEach(link => {
                link.addEventListener('click', e => {
                    e.preventDefault();

                    const href = link.getAttribute('href') || '';
                    const targetId = href.split('#')[1];
                    const targetElement = document.getElementById(targetId);
                    if (!targetElement) return;

                    const headerScroll = document.querySelector('.header-scroll');
                    const eventStickyNav = document.querySelector('.event-sticky__nav');

                    const stickyNavHeight = headerScroll ? headerScroll.offsetHeight : 0;
                    const eventNavHeight = eventStickyNav ? eventStickyNav.offsetHeight : 0;

                    const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - stickyNavHeight - eventNavHeight;

                    window.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth'
                    });

                    setActiveLink(link);
                });
            });
        }

        const updateActiveLinkOnScroll = () => {
            let currentSection = '';

            sectionsFilter.forEach(section => {
                const sectionTop = section.offsetTop;
                const sectionBottom = sectionTop + section.offsetHeight;
                const viewportMiddle = window.scrollY + window.innerHeight / 2;

                if (viewportMiddle >= sectionTop && viewportMiddle < sectionBottom) {
                    currentSection = section.getAttribute('id');
                }
            });

            if (currentSection) {
                const activeLink = navLinks.find(link => {
                    const href = link.getAttribute('href') || '';
                    const id = href.includes('#') ? href.split('#')[1] : null;
                    return id === currentSection;
                });

                if (activeLink && !activeLink.classList.contains('active')) {
                    setActiveLink(activeLink);
                }
            } else {
                navLinks.forEach(link => link.classList.remove('active'));
            }
        };

        window.addEventListener('scroll', updateActiveLinkOnScroll);
        window.addEventListener('resize', () => {
            updateActiveLinkOnScroll();
        });

        updateActiveLinkOnScroll();
    }

}


